import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useHtClient } from '../providers/ht';

// Advisor notes on a client (F16). Staff-only on the backend; advisors see their own
// firm's notes, admins see all. Never shown to the client.
export interface ClientNote {
  id: number;
  sf_account: string;
  firm_id: number | null;
  author_profile: string;
  author_name: string | null;
  body: string;
  created_at: string;
}

export const useClientNotes = (sfAccount: string | undefined) => {
  const { data: client } = useHtClient();
  return useQuery<ClientNote[]>({
    queryKey: ['clientNotes', sfAccount],
    queryFn: async () => {
      if (!client) throw new Error('API client not initialized');
      const res = await client.get(`/client-notes/${encodeURIComponent(sfAccount as string)}`);
      return res.data;
    },
    enabled: !!client && !!sfAccount,
  });
};

export const useAddClientNote = (sfAccount: string | undefined) => {
  const { data: client } = useHtClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: string) => {
      if (!client) throw new Error('API client not initialized');
      const res = await client.post(`/client-notes/${encodeURIComponent(sfAccount as string)}`, { body });
      return res.data as ClientNote;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['clientNotes', sfAccount] }),
  });
};
